import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { DataService } from './data.service';
import { AuthService } from './auth.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { NavigationEnd, NavigationSkipped, Router } from '@angular/router';
declare let window: any;
declare var gtag: any;
@Injectable({
    providedIn: 'root'
})
export class ScriptsService {

    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        @Inject(DOCUMENT) private doc: Document,
        private data: DataService,
        private auth: AuthService
    ) {
    }

    createGoogleScript(data: any) {
        if (isPlatformBrowser(this.platformId)) {
            const headTag = this.doc.getElementsByTagName('head')[0];
            if (data.google_analytics_id) {
                const scriptGoogleTag = this.doc.createElement('script');
                scriptGoogleTag.src = "https://www.googletagmanager.com/gtag/js?id=" + data.google_analytics_id;
                headTag.prepend(scriptGoogleTag);

                const script = this.doc.createElement('script');
                script.innerHTML = "window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '" + data.google_analytics_id + "');";
                headTag.prepend(script);
            }
            
            if (data.google_tag_manager_id) {
                const scriptGoogleTagManager = this.doc.createElement('script');
                scriptGoogleTagManager.innerHTML = "(function (w, d, s, l, i) {w[l] = w[l] || []; w[l].push({'gtm.start':new Date().getTime(), event: 'gtm.js'}); var f = d.getElementsByTagName(s)[0],j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src ='https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);}) (window, document, 'script', 'dataLayer', '" + data.google_tag_manager_id +"'); ";
                headTag.prepend(scriptGoogleTagManager);
            }
        }
    }
    createMetaScript(data:any) {
        if (isPlatformBrowser(this.platformId)) {
            const headTag = this.doc.getElementsByTagName('head')[0];
            if (data) {
                const noJavascriptTag = this.doc.createElement('noscript');
                const noJavascriptTagString = "<img height=\"1\" width=\"1\" style=\"display:none\"\nsrc=\"https://www.facebook.com/tr?id=" + data + "&ev=PageView&noscript=1\"\n/>";
                noJavascriptTag.innerHTML = noJavascriptTagString;
                headTag.appendChild(noJavascriptTag);

                const script = this.doc.createElement('script');
                script.innerHTML = "!function(f,b,e,v,n,t,s)\r\n{if(f.fbq)return;n=f.fbq=function(){n.callMethod?\r\nn.callMethod.apply(n,arguments):n.queue.push(arguments)};\r\nif(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\r\nn.queue=[];t=b.createElement(e);t.async=!0;\r\nt.src=v;s=b.getElementsByTagName(e)[0];\r\ns.parentNode.insertBefore(t,s)}(window, document,'script',\r\n'https://connect.facebook.net/en_US/fbevents.js');\r\nfbq('init', '" + data + "');\r\nfbq('track', 'PageView');";
                headTag.appendChild(script);
            }
        }
    }

    createBigoScript(data :any) {
        if (isPlatformBrowser(this.platformId)) {
            const headTag = this.doc.getElementsByTagName('head')[0];
            if (data) {
                const scriptBigo = this.doc.createElement('script');
                scriptBigo.async =  true;
                scriptBigo.src = "https://api.imotech.video/ad/events.js?pixel_id=" + data;
                headTag.appendChild(scriptBigo);

                const script = this.doc.createElement('script');
                script.innerHTML = "window.bgdataLayer = window.bgdataLayer || [];\r\n  function bge(){bgdataLayer.push(arguments);}\r\n  bge('init', '" + data + "');";
                headTag.appendChild(script);
            }
        }
    }
    createKwaiScript(data:any){
        if (isPlatformBrowser(this.platformId)) {
            const headTag = this.doc.getElementsByTagName('head')[0];
            if (data) {
                // console.log('test');
                const script = this.doc.createElement('script');
                script.innerHTML = "!function(e,t){\"object\"==typeof exports&&\"object\"==typeof module?module.exports=t():\"function\"==typeof define&&define.amd?define([],t):\"object\"==typeof exports?exports.install=t():e.install=t()}(window,(function(){return function(e){var t={};function n(o){if(t[o])return t[o].exports;var r=t[o]={i:o,l:!1,exports:{}};return e[o].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=e,n.c=t,n.d=function(e,t,o){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:o})},n.r=function(e){\"undefined\"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:\"Module\"}),Object.defineProperty(e,\"__esModule\",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&\"object\"==typeof e&&e&&e.__esModule)return e;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,\"default\",{enumerable:!0,value:e}),2&t&&\"string\"!=typeof e)for(var r in e)n.d(o,r,function(t){return e[t]}.bind(null,r));return o},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,\"a\",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p=\"\",n(n.s=0)}([function(e,t,n){\"use strict\";var o=this&&this.__spreadArray||function(e,t,n){if(n||2===arguments.length)for(var o,r=0,i=t.length;r<i;r++)!o&&r in t||(o||(o=Array.prototype.slice.call(t,0,r)),o[r]=t[r]);return e.concat(o||Array.prototype.slice.call(t))};Object.defineProperty(t,\"__esModule\",{value:!0});var r=function(e,t,n){var o,i=e.createElement(\"script\");i.type=\"text/javascript\",i.async=!0,i.src=t,n&&(i.onerror=function(){r(e,n)});var a=e.getElementsByTagName(\"script\")[0];null===(o=a.parentNode)||void 0===o||o.insertBefore(i,a)};!function(e,t,n){e.KwaiAnalyticsObject=n;var i=e[n]=e[n]||[];i.methods=[\"page\",\"track\",\"identify\",\"instances\",\"debug\",\"on\",\"off\",\"once\",\"ready\",\"alias\",\"group\",\"enableCookie\",\"disableCookie\"];var a=function(e,t){e[t]=function(){for(var n=[],r=0;r<arguments.length;r++)n[r]=arguments[r];var i=o([t],n,!0);e.push(i)}};i.methods.forEach((function(e){a(i,e)})),i.instance=function(e){var t,n=(null===(t=i._i)||void 0===t?void 0:t[e])||[];return i.methods.forEach((function(e){a(n,e)})),n},i.load=function(e,o){var a=\"https://s1.kwai.net/kos/s101/nlav11187/pixel/events.js\";i._i=i._i||{},i._i[e]=[],i._i[e]._u=a,i._t=i._t||{},i._t[e]=+new Date,i._o=i._o||{},i._o[e]=o||{};var c=\"?sdkid=\".concat(e,\"&lib=\").concat(n);r(t,a+c,\"https://s16-11187.ap4r.com/kos/s101/nlav11187/pixel/events.js\"+c)}}(window,document,\"kwaiq\")}])}));\nkwaiq.load('" + data + "');\nkwaiq.page();";
                headTag.appendChild(script);
            }
        }
    }

    createPureChat(data: any) {
        const headTag = this.doc.getElementsByTagName('head')[0];
        if ((data.engine).toLowerCase() === 2 || (data.engine).toLowerCase() === 'purechat') {
            // const funcTagString = "<script type='text/javascript' data-cfasync='false'>window.purechatApi = { l: [], t: [], on: function () { this.l.push(arguments); } }; (function () { var done = false; var script = document.createElement('script'); script.async = true; script.type = 'text/javascript'; script.src = 'https://app.purechat.com/VisitorWidget/WidgetScript'; document.getElementsByTagName('HEAD').item(0).appendChild(script); script.onreadystatechange = script.onload = function (e) { if (!done && (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete')) { var w = new PCWidget({c: '" + data.id + "', f: true }); done = true; } }; })();</script>";
            // let funcTag = new DOMParser().parseFromString(funcTagString, 'text/html');
            // let funcTagDoc = funcTag.getRootNode() as any;
            // funcTagDoc.head.childNodes.forEach((c: any) => {
            //     headTag.appendChild(c);
            // });

            const script = this.doc.createElement('script');
            script.setAttribute('data-cfasync', 'false');
            script.innerHTML = "window.purechatApi = { l: [], t: [], on: function () { this.l.push(arguments); } }; (function () { var done = false; var script = document.createElement('script'); script.async = true; script.type = 'text/javascript'; script.src = 'https://app.purechat.com/VisitorWidget/WidgetScript'; document.getElementsByTagName('HEAD').item(0).appendChild(script); script.onreadystatechange = script.onload = function (e) { if (!done && (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete')) { var w = new PCWidget({c: '" + data.id + "', f: true }); done = true; } }; })();";

            headTag.appendChild(script);
        }
    }

    createTawkto(data: any) {
        const bodyTag = this.doc.getElementsByTagName('body')[0];
        const chatContainerID = this.doc.getElementById('chatcontainer'); 

        if ((data.engine).toLowerCase() === 3 || (data.engine).toLowerCase() === 'tawk.to') {
            const script = this.doc.createElement('script');
            script.innerHTML = "var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date(); Tawk_API.autoStart = true; (function(){ var s1=document.createElement(\"script\"),s0=document.getElementsByTagName(\"script\")[0]; s1.async=true; s1.src='https://embed.tawk.to/" + data.page_name + "/" + data.id + "'; s1.charset='UTF-8'; s1.setAttribute('crossorigin','*'); s0.parentNode.insertBefore(s1,s0); })();window.Tawk_API.hideWidget();";
            
            if (!chatContainerID) {
                const chatContainer = this.doc.createElement('div');
                chatContainer.id = 'chatcontainer';
                bodyTag.appendChild(chatContainer);
                chatContainer.appendChild(script);
            }
        }
    }

    googleConversionLogin(username:string, phone:string) {
        gtag('event', 'login', {
            'method': 'website',
            'username': username,
            'phone': phone,
        });
    }

    googleConversionRegister(username: string, phone:string ,bank_name :string, bank_number: string, account_name:string, referral:string) {
        gtag('event', 'sign_up', {
            'method': 'website',
            'username': username,
            'phone': phone,
            'bank_name': bank_name,
            'bank_number': bank_number,
            'account_name': account_name,
            'referral': referral
        });
    }

    googleConversionDP(value: string, transaction_id: string, promo: string, fee: string, username: string, phone: string, bank_name: string, bank_number: string, account_name: string, referral: string) {
        gtag('event', 'purchase', {
            'currency': 'IDR',
            'value': value,
            'transaction_id': transaction_id,
            'coupon': promo,
            'tax': fee,
            'username': username,
            'phone': phone,
            'bank_name': bank_name,
            'bank_number': bank_number,
            'account_name': account_name,
            'referral': referral,
        });
    }

    createLivechat(data: any) {
        const bodyTag = this.doc.getElementsByTagName('body')[0];
        const chatContainerID = this.doc.getElementById('chatcontainer');

        if ((data.engine).toLowerCase() === 1 || (data.engine).toLowerCase() === 'livechatinc' || (data.engine).toLowerCase() === 'livechat' || (data.engine).toLowerCase() === 'livechat.com') {
            const script = this.doc.createElement('script');
            script.innerHTML = "window.__lc = window.__lc || {};\r\n    window.__lc.license = " + data.id + ";\r\n    window.__lc.integration_name = \"manual_onboarding\";\r\n    window.__lc.product_name = \"livechat\";\r\n    window.__lc.asyncInit = false;\r\n ;(function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:\"2.0\",on:function(){i([\"on\",c.call(arguments)])},once:function(){i([\"once\",c.call(arguments)])},off:function(){i([\"off\",c.call(arguments)])},get:function(){if(!e._h)throw new Error(\"[LiveChatWidget] You can't use getters before load.\");return i([\"get\",c.call(arguments)])},call:function(){i([\"call\",c.call(arguments)])},init:function(){var n=t.createElement(\"script\");n.async=!0,n.type=\"text/javascript\",n.src=\"https://cdn.livechatinc.com/tracking.js\",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))";
            // if (window.LiveChatWidget) {
            //     window.LiveChatWidget.init();
            // }

            // console.log(chatContainerID);
            if(!chatContainerID){
                const chatContainer = this.doc.createElement('div');
                chatContainer.id = 'chatcontainer';
                bodyTag.appendChild(chatContainer);
                chatContainer.appendChild(script);
            }
        }
    }

    hideChat(data:any){
        if ((data.engine).toLowerCase() === 1 || (data.engine).toLowerCase() === 'livechatinc' || (data.engine).toLowerCase() === 'livechat' || (data.engine).toLowerCase() === 'livechat.com') {

            let onReady = () => {
                if (window.LiveChatWidget) {
                    window.LiveChatWidget.call("hide");
                    // windowLiveChatWidget.call("destroy");
                }
                console.log('remove');
            }
            
            // console.log('REMOVE')
            if(window.LiveChatWidget){
                // window.LiveChatWidget.call("hide");
                window.LiveChatWidget.on('ready', onReady)
            }

            
        }
        if ((data.engine).toLowerCase() === 3 || (data.engine).toLowerCase() === 'tawk.to') {
            // console.log(Object.getOwnPropertyNames(window.Tawk_API).length)
            if(Object.getOwnPropertyNames(window.Tawk_API).length === 1){
                window.Tawk_API.onBeforeLoad =  () => {
                    window.Tawk_API.hideWidget();
                };
            } else {
                window.Tawk_API.hideWidget();
            }

        }
    }

    showChat(data:any){
        if ((data.engine).toLowerCase() === 1 || (data.engine).toLowerCase() === 'livechatinc' || (data.engine).toLowerCase() === 'livechat' || (data.engine).toLowerCase() === 'livechat.com') {
            // console.log('SHOW')
            let onReady = ()=>{
                if (window.LiveChatWidget) {
                    window.LiveChatWidget.call("minimize");
                }
                console.log('ready');
            }
            if (window.LiveChatWidget) {
                window.LiveChatWidget.on('ready', onReady)
            }
        }
        if ((data.engine).toLowerCase() === 3 || (data.engine).toLowerCase() === 'tawk.to') {
            // console.log('SHOW');
            window.Tawk_API.onStatusChange = (status:any) => {
                if (status === 'online') {
                    window.Tawk_API.showWidget();
                }
            };
            if (Object.getOwnPropertyNames(window.Tawk_API).length === 1) {
                window.Tawk_API.onLoad = () => {
                    window.Tawk_API.showWidget();
                };
            } else {
                window.Tawk_API.showWidget();
            }
        }
    }

    removeCustomScript(){
        const customscriptContainer = this.doc.getElementById('customscript');
        // console.log('check customscript')
        if (customscriptContainer) {
            // console.log('remove customscript')
            customscriptContainer.style.display = 'none';
            customscriptContainer.style.visibility = 'hidden';
        }
        // customscriptContainer?.remove();
    }
    displayCustomScript(){
        const customscriptContainer = this.doc.getElementById('customscript');
        // console.log('check customscript (display)')
        if (customscriptContainer) {
            // console.log('display customscript')
            customscriptContainer.style.display = 'block';
            customscriptContainer.style.opacity = '1';
            customscriptContainer.style.visibility = 'visible';
        }
        // customscriptContainer?.remove();
    }
}

/** A router wrapper, adding extra functions. */
@Injectable({
    providedIn: 'root'
})
export class RouterExtService {

    private previousUrl: string = '';
    private currentUrl: string = '';

    constructor(private router: Router) {
        this.currentUrl = this.router.url;
        this.router.events.subscribe(event => {
            // console.log(this.currentUrl)
            // console.log(this.previousUrl)
            // console.log(this.currentUrl)
            if (event instanceof NavigationSkipped) {
                this.previousUrl = this.currentUrl;
                this.currentUrl = event.url;
            };
            if (event instanceof NavigationEnd) {
                this.previousUrl = this.currentUrl;
                this.currentUrl = event.url;
            };
        });
    }

    public getPreviousUrl() {
        // console.log(this.previousUrl)
        if (this.previousUrl === '/withdrawal' || this.previousUrl === '/deposit'){
            this.previousUrl = '/'
        }
        return this.previousUrl;
    }
}